/* import __COLOCATED_TEMPLATE__ from './notifications-component.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class NotificationsComponent extends Component {
  @service notificationsService;
}
